import { ALWAYS_BLOCK_SELECTORS, SENSITIVE_ATTRIBUTES } from './constants';

/**
 * Verifica si un elemento o ALGUNO de sus ancestros está en la blacklist.
 * Recorre hacia arriba para que bloquear un contenedor bloquee su subárbol.
 */
export function isElementBlocked(element: Element, extraBlockSelectors: string[] = []): boolean {
  const allBlockers = [...ALWAYS_BLOCK_SELECTORS, ...extraBlockSelectors];
  let current: Element | null = element;

  while (current && current !== document.documentElement) {
    for (const selector of allBlockers) {
      try {
        if (current.matches(selector)) return true;
      } catch {
        // Selector inválido o no soportado por el motor: ignorar y seguir.
      }
    }
    current = current.parentElement;
  }

  return false;
}

/** Verifica si un atributo es sensible y debe omitirse. */
export function isSensitiveAttribute(attrName: string): boolean {
  const lower = attrName.toLowerCase();
  return SENSITIVE_ATTRIBUTES.includes(lower) || /password|secret|token|ssn|credit/i.test(attrName);
}

/** Obtiene el texto visible de un elemento, respetando privacidad. */
export function safeGetText(element: Element, maxLength: number, mask: boolean): string {
  if (mask) return '';

  // Nunca capturar texto de campos de entrada (puede contener lo que el usuario escribe).
  const tagName = element.tagName.toLowerCase();
  if (tagName === 'input' || tagName === 'textarea') return '';

  // `innerText` no existe en jsdom; el fallback a `textContent` lo cubre.
  const raw =
    (element instanceof HTMLElement ? element.innerText : '') || element.textContent || '';
  const trimmed = raw.trim().replace(/\s+/g, ' ');

  return trimmed.length > maxLength ? `${trimmed.slice(0, maxLength)}…` : trimmed;
}
